<template>
    <div class="feed-display-switches extra-light-text no-select">
        <i class="far fa-bars hover-opacity mimic-title feed-display-switch feed-display-switch-compact" :class="{'secondary-c': displayMode === 'small'}" @click="setDisplay('small')">
            <span>{{ translations['forum.compact_view'] }}</span>
        </i>
        <i class="far fa-th-large hover-opacity mimic-title feed-display-switch feed-display-switch-big" :class="{'secondary-c': displayMode === 'big'}" @click="setDisplay('big')">
            <span>{{ translations['forum.card_view'] }}</span>
        </i>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import {mapState} from 'vuex';

    export default {
        name: 'DisplayMode',

        computed: {
            ...mapState([
                'displayMode',
                'translations'
            ]),
        },

        methods: {
            setDisplay(mode) {
                if(this.displayMode !== mode) {
                    this.$store.commit('setDisplayMode', mode);

                    Cookies.set('feeddisplaystatus', mode, {
                        expires: 365
                    });
                }
            }
        },

        mounted() {
            let cookie = Cookies.get('feeddisplaystatus');

            if(cookie !== undefined) {
                this.$store.commit('setDisplayMode', cookie);
            }
        },
    }
</script>

<style lang="scss">

</style>